const statsElements = document.querySelectorAll(".stats");

if (statsElements.length) {
  const extractNumberParts = (text) => {
    const str = String(text ?? "").trim();
    const match = str.match(/-?\d[\d,]*\.?\d*/);
    if (!match || match.index == null) return null;

    const numberStr = match[0];
    const prefix = str.slice(0, match.index);
    const suffix = str.slice(match.index + numberStr.length);

    const decimals = (numberStr.split(".")[1] ?? "").length;
    const useCommas = numberStr.includes(",");
    const value = Number.parseFloat(numberStr.replace(/,/g, ""));
    if (!Number.isFinite(value)) return null;

    return {
      prefix,
      suffix,
      decimals,
      useCommas,
      value,
      finalText: str,
    };
  };

  const formatNumber = (value, { decimals, useCommas }) => {
    if (useCommas) {
      return value.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    }

    if (decimals > 0) return value.toFixed(decimals);
    return String(Math.round(value));
  };

  const animateNumber = (el) => {
    const originalText = el.textContent ?? "";
    const parts = extractNumberParts(originalText);
    if (!parts) return;

    const dataValueRaw = el.getAttribute("data-value");
    const dataValue = dataValueRaw
      ? Number.parseFloat(String(dataValueRaw).replace(/,/g, ""))
      : Number.NaN;
    const target = Number.isFinite(dataValue) ? dataValue : parts.value;

    let current = 0;
    const steps = 60;
    const increment = target / steps;

    const interval = setInterval(() => {
      current += increment;

      if (current >= target) {
        clearInterval(interval);
        el.textContent = parts.finalText;
        return;
      }

      el.textContent = `${parts.prefix}${formatNumber(current, parts)}${parts.suffix}`;
    }, 16);
  };

  const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const statsNumbers = entry.target.querySelectorAll(".stats__number");
      statsNumbers.forEach((numberEl) => animateNumber(numberEl));

      observer.unobserve(entry.target);
    });
  };

  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    threshold: 0.5,
    rootMargin: "0px",
  });

  statsElements.forEach((el) => observer.observe(el));
}